import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AboutYouForm, AboutYouHealthForm } from '@models/DPI/AboutYou.model';
export interface LoadingState {
  income: AboutYouForm | null,
  health: AboutYouHealthForm | null,
  isCompleted: boolean;
}

const initialState: LoadingState = {
  income: null,
  health: null,
  isCompleted: false

}

const step3Slice = createSlice({
  name: 'DPI-Step3',
  initialState,
  reducers: {
    updateIncome: (state, action: PayloadAction<AboutYouForm> ) => {
      state.income = action.payload;
    },
    updateHealth: (state, action: PayloadAction<AboutYouHealthForm> ) => {
      state.health = action.payload;
    },
    completeStep: (state, action: PayloadAction<boolean>) => {
      state.isCompleted = action.payload;
    }
  },
  extraReducers: {}
})

export const {  updateHealth, updateIncome, completeStep } = step3Slice.actions;

export default step3Slice.reducer;